import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

// Helper function to extract serializable error data
const getErrorMessage = (error) => {
  return {
    message: error?.response?.data?.message || error?.message || "An error occurred",
    status: error?.response?.status,
    code: error?.code,
  };
};

function* handleFetchSampleCoverage(action) {
  const { filtersString } = action.payload;
  try {
    const response = yield call(API.fetchSampleCoverageSummary, {
      filtersString,
      sortDescending: true,
    });
    yield put(actions.fetchSampleCoverageSuccess(response.data));
  } catch (error) {
    yield put(actions.fetchSampleCoverageFailure(getErrorMessage(error)));
  }
}

function* handleFetchDistrictData(action) {
  const { filtersString } = action.payload;
  try {
    const response = yield call(API.fetchGeographyAnalytics, {
      filtersString,
      sortDescending: true,
    });
    const districtData =
      response.data?.data?.filter((item) => item.district) || [];
    yield put(actions.fetchDistrictDataSuccess({ data: districtData }));
  } catch (error) {
    yield put(actions.fetchDistrictDataFailure(getErrorMessage(error)));
  }
}

function* handleFetchComplianceData(action) {
  const {
    filtersString,
    dimension = "Overall",
    level = "both",
  } = action.payload;
  try {
    const response = yield call(API.fetchComplianceGeographyData, {
      filtersString,
      dimension,
      level,
    });
    yield put(actions.fetchComplianceDataSuccess(response.data));
  } catch (error) {
    yield put(actions.fetchComplianceDataFailure(getErrorMessage(error)));
  }
}

export function* sampleCoverageSaga() {
  yield takeLatest(actions.fetchSampleCoverage.type, handleFetchSampleCoverage);
  yield takeLatest(actions.fetchDistrictData.type, handleFetchDistrictData);
  yield takeLatest(actions.fetchComplianceData.type, handleFetchComplianceData);
}